import { render, staticRenderFns } from "./GerarRelatoriosFinanceiros.vue?vue&type=template&id=84e54cb2&scoped=true&"
import script from "./GerarRelatoriosFinanceiros.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosFinanceiros.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosFinanceiros.vue?vue&type=style&index=0&id=84e54cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e54cb2",
  null
  
)

export default component.exports